const DOCUMENT = {
  CPF: 'CPF',
  CNPJ: 'CNPJ'
};

/**
 * Mantém letras para novo CNPJ alfanumérico
 */
const normalize = (value = '') => {
  return value
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');
};

/**
 * Detecta se deve usar CPF ou CNPJ
 *
 * Regra:
 * - possui letra => CNPJ
 * - até 11 chars numéricos => CPF
 * - acima de 11 => CNPJ
 */
const detectDocumentType = (value) => {
  const clean = normalize(value);

  if (/[A-Z]/.test(clean)) {
    return DOCUMENT.CNPJ;
  }

  return clean.length <= 11
    ? DOCUMENT.CPF
    : DOCUMENT.CNPJ;
};

/**
 * CPF
 * 999.999.999-99
 */
const formatCPF = (value) => {
  const clean = value
    .replace(/\D/g, '')
    .slice(0, 11);

  return clean
    .replace(/^(\d{3})(\d)/, '$1.$2')
    .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1-$2');
};

/**
 * Novo CNPJ alfanumérico
 * 99.ABC.123/0001-99
 */
const formatCNPJ = (value) => {
  const clean = normalize(value).slice(0, 14);

  let result = clean;

  if (result.length > 2) {
    result = result.replace(/^(.{2})(.+)/, '$1.$2');
  }

  if (result.length > 6) {
    result = result.replace(/^(.{6})(.+)/, '$1.$2');
  }

  if (result.length > 10) {
    result = result.replace(/^(.{10})(.+)/, '$1/$2');
  }

  if (result.length > 15) {
    result = result.replace(/^(.{15})(.+)/, '$1-$2');
  }

  return result;
};

export const maskDocumentCpfCnpj = (value) => {
  const type = detectDocumentType(value);

  if (type === DOCUMENT.CPF) {
    return formatCPF(value);
  }

  return formatCNPJ(value);
};
